import type { ReactNode } from 'react';

export function PageHeader({ title, description }: { title: string; description: ReactNode }) {
  return (
    <header className="mb-6">
      <h1 className="text-3xl font-bold text-foreground">{title}</h1>
      <p className="mt-2 max-w-prose text-muted-foreground">{description}</p>
    </header>
  );
}
